/* eslint-disable react/prop-types */
import React, { createContext, useContext, useState } from 'react';

import { useDataModel, QueryProvider } from '@thd-nucleus/data-sources';
import { PlccDrawerContentDataModel, PlccPromoInfoDataModel } from '../contentful/dataModel/dataModel';

const ContentfulContext = createContext();

export const useContentfulContext = () => {
  return useContext(ContentfulContext);
};

export const ContentfulProvider = ({ children }) => {
  const [state, setState] = useState({});

  const { data: plccDrawerData = {}, error: plccDrawerDataError = null } = useDataModel('component', {
    variables: { id: 'GYuwVyFrBbvMmYoyMZdl6', componentClass: 'PlccDrawerContent' },
    dataModel: PlccDrawerContentDataModel,
  });

  const { data: plccData = {}, error: plccDataError = null } = useDataModel('component', {
    variables: { id: '2mf1i1OmapsjB3PCzwGynI', componentClass: 'PlccPromoInfo' },
    dataModel: PlccPromoInfoDataModel,
  });

  const updateState = (newState) => {
    setState((prevState) => ({ ...prevState, ...newState }));
  };

  if (plccDrawerDataError || plccDataError) {
    // eslint-disable-next-line no-console
    console.error('Error fetching contentful data.');
  }

  return (
    <ContentfulContext.Provider
      value={{
        state,
        updateState,
        plccDrawerData,
        plccDrawerDataError,
        plccData,
      }}
    >
      {children}
    </ContentfulContext.Provider>
  );
};
